import { ev, isMobile } from '../utils';
import initCustomCursor from './Cursor';
import $ from 'jquery';

import lottie from 'lottie-web';
import gsap from 'gsap';
import { lottieSplashScreen } from './lottie';

function animationSplashScreen() {
	const splashContainer = document.querySelector('[data-splash="container"]');
	if (!splashContainer) return;

	const splashValueSpan = splashContainer.querySelector('[data-splash="value"] span');
	const splashCta = splashContainer.querySelector('[data-splash="cta"]');
	const showMenuButton = splashContainer.querySelector('[data-splash-menu-btn]');

	const overlayVideo = document.querySelector('[data-video-overlay]');
	const $btnBurger = $('.burger-btn-block .btn-burger');

	let isLoaded = false;

	// let isVideoRevealed = false;
	let interval;

	splashCta.addEventListener('click', () => {
		if (!isLoaded) return;
		hideSplash(false, true);
		document.body.classList.add('is-burger-visible');
	});

	showMenuButton.addEventListener('click', () => {
		if (!isLoaded) return;

		hideSplash(true);
		$('.menu_items').addClass('articles-first');
		$btnBurger.trigger('click', [false]);
		ev('showBurgerBtn', {});
		document.body.classList.add('is-burger-visible');
		initCustomCursor();
	});

	const hideSplash = (isMuted = false, showVideoOverlay = false) => {
		clearInterval(interval);
		// isVideoRevealed = true;

		ev('initVideo', {
			muted: isMuted,
			autoplay: false,
		});

		ev('showVideoOverlay', {
			isMuted: isMuted,
			showVideoOverlay: showVideoOverlay,
		});

		gsap.to(splashContainer, {
			opacity: 0,
			duration: 1,
			ease: 'power2.out',
			pointerEvents: 'none',
			onComplete: () => {
				splashContainer.style.display = 'none';
			},
		});
	};

	let count;

	function setTimer(time = 10) {
		count = time;

		if (splashValueSpan) {
			splashValueSpan.textContent = count;

			interval = setInterval(() => {
				count--;
				splashValueSpan.textContent = count;

				if (count === 0) {
					clearInterval(interval);
					// if (!isVideoRevealed) revealVideo(true);
					hideSplash(true, true);
					document.body.classList.add('is-burger-visible');
				}
			}, 1000);
		}
	}

	if (!(window.matchMedia('(orientation: landscape)').matches && isMobile)) {
		// console.log('setTimer matchMedia');
		setTimer();
	}

	document.addEventListener('orientationchange', (e) => {
		const { orientation } = e.detail;

		if (orientation == 'landscape') {
			//console.log('orientationchange landscape');
			clearInterval(interval);
		} else {
			//console.log('orientationchange portrait');

			if (count > 0) setTimer(count);
		}
	});

	const selectors = ['subTitle', 'title', 'text', 'btn', 'textDesc'].map((item) =>
		splashContainer.querySelector(`[data-splash="${item}"]`),
	);
	const [splashSubTitle, splashTitle, splashText, splashBtn, splashTextDesc] = selectors;

	const defaultAnimationProps = {
		y: 0,
		force3D: true,
		duration: 1,
		opacity: 1,
		ease: 'power2.out',
	};

	const playFlowersAnimation = lottieSplashScreen(lottie);

	const tl = gsap.timeline({
		paused: true,
		onComplete: () => {
			// playFlowersAnimation();
			// ev('splashCompleted');
			// isLoaded = true;
		},
	});

	const startPoint = 1;

	tl.to(splashContainer.querySelectorAll('[data-splash="cloud"]'), { ...defaultAnimationProps }, startPoint)
		.fromTo(
			splashSubTitle,
			{ y: 90, opacity: 0 },
			{
				...defaultAnimationProps,
				// onComplete: () => playFlowersAnimation(),
			},
			startPoint,
		)
		.fromTo(splashTitle, { y: 70, opacity: 0 }, { ...defaultAnimationProps }, startPoint)
		.fromTo(
			splashText,
			{ y: 90, opacity: 0 },
			{
				...defaultAnimationProps,
				onComplete: () => {
					playFlowersAnimation();
					ev('splashCompleted');
					isLoaded = true;

					gsap.to(splashBtn, {
						pointerEvents: 'auto',
					});
				},
			},
			startPoint,
		)
		.fromTo(
			splashBtn,
			{ y: 70, opacity: 0 },
			{
				...defaultAnimationProps,
				delay: 0.2,
				onStart: () => {
					gsap.to(splashBtn, {
						pointerEvents: 'none',
					});
				},
			},
			startPoint,
		)
		.fromTo(splashTextDesc, { y: 90, opacity: 0 }, { ...defaultAnimationProps }, startPoint);

	tl.play();

	// lottieSplashScreen(() => {
	// 	// tl.play();
	// });
}

export { animationSplashScreen };
